import { ActionCreator } from "./../types/store-types.d";
import {
    AddMessageActionType,
    ChatActionTypes,
    SendMessageFailureActionType,
    SendMessageRequestActionType,
    SendMessageSuccessActionType,
    ToggleChatBotActionType,
} from "./types";

export const toggleChatBot: ActionCreator<ToggleChatBotActionType> = payload => ({
    type: ChatActionTypes.TOGGLE_CHAT,
    payload,
});

export const addMessage: ActionCreator<AddMessageActionType> = payload => ({
    type: ChatActionTypes.ADD_MESSAGE,
    payload,
});

export const sendMessageRequest: ActionCreator<SendMessageRequestActionType> = payload => ({
    type: ChatActionTypes.SEND_MESSAGE_REQUEST,
    payload,
});

export const sendMessageSuccess: ActionCreator<SendMessageSuccessActionType> = payload => ({
    type: ChatActionTypes.SEND_MESSAGE_SUCCESS,
    payload,
});

export const sendMessageFailure: ActionCreator<SendMessageFailureActionType> = payload => ({
    type: ChatActionTypes.SEND_MESSAGE_FAILURE,
    payload,
});
